import { createAsyncThunk } from "@reduxjs/toolkit";
import Axios  from "../../Services/Api/Index";
import { API_PATH } from '../../Constants/ApiPath';
import { API_TYPE } from "../../Constants/ApiType";
import { LANGUAGES } from "../../Constants/Constant";
import { setCalendarData } from "./slice";

export const getSlots = createAsyncThunk(
  "calendar/getSlots",
  async(payload,{rejectWithValue, dispatch})=>{
    try{
      const lang_code = localStorage.getItem("lang_type");
      const response = await Axios({
        method: API_TYPE.POST,
        url: API_PATH.SLOTS_DETAILS,
        data: payload,
        headers: {
          "Accept-Language": lang_code || LANGUAGES.JP,
        },
      });
      const data = await response.data;
      if (data.status === "success" && data.statuscode === 200) {
        return { ...data.data }
      }
      throw data.message || "Something went wrongggg!";
    }catch(err){
        console.log("err - ",err);
      return rejectWithValue(err);
    }
  }
);

export const getProviderCalendar = createAsyncThunk(
  "calendar/getProviderCalendar",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const lang_code = localStorage.getItem("lang_type");
      const response = await Axios({
        method: API_TYPE.POST,
        url: API_PATH.PROVIDER_DETAILS,
        data: payload,
        headers: {
          "Accept-Language": lang_code || LANGUAGES.JP,
        },
      });
      const data = await response.data;
      if (data.status === "success" && data.statuscode === 200) {
        dispatch(setCalendarData({ disabledDates: data.data?.disabledDates }));
        return { ...data.data };
      }
      throw data.message || "Failed to fetch provider calendar";
    } catch (err) {
      console.log("err - ", err);
      return rejectWithValue(err);
    }
  }
);